module.exports = __webpack_public_path__ + "static/media/Ahmad-removebg-preview.5fa86ad1.png";